import React, { FC, useMemo } from 'react'

import { AssignProjectListTopTitle } from 'src/components/molecules'
import { AssignProjectList, NoAssignProject } from 'src/components/organisms'
import { UserAssignProjectsSearchArea } from 'src/components/organisms/users/UserAssignProjectsSearchArea'

import { useProject } from 'src/hooks'
import { AssignedProjectEntity, AssignedProjectSearchContentEntity } from 'src/types'

type Props = {
  projects: AssignedProjectEntity[]
  onClickRow: (project: AssignedProjectEntity) => void
  searchContent: AssignedProjectSearchContentEntity | null
  editButtonId: string
  cancelButtonId: string
  onUpdateSearchContent: (searchContent: AssignedProjectSearchContentEntity | null) => void
  onToEditMode: () => void
  className?: string
}

/**
 * 編集モードではない通常時のユーザー詳細のアサインプロジェクトを表示するコンポーネント
 */
export const UserAssignProjectsContent: FC<Props> = ({
  projects,
  onClickRow,
  searchContent,
  editButtonId,
  cancelButtonId,
  onUpdateSearchContent,
  onToEditMode,
  className,
}) => {
  const { getIsProjectMatch } = useProject()

  const filteredProjects = useMemo(() => {
    if (!searchContent) {
      return projects
    }

    return projects.filter(project => getIsProjectMatch(project, searchContent))
  }, [getIsProjectMatch, projects, searchContent])

  return (
    <div className={className}>
      <AssignProjectListTopTitle
        editButtonId={editButtonId}
        cancelButtonId={cancelButtonId}
        onClickEdit={onToEditMode}
      />
      <UserAssignProjectsSearchArea
        editButtonId={editButtonId}
        cancelButtonId={cancelButtonId}
        searchContent={searchContent}
        allAssignedProjectCount={projects.length}
        displayedProjectStatuses={filteredProjects.map(p => p.status)}
        onUpdateSearchContent={onUpdateSearchContent}
        className="tw-mt-s1"
      />

      <div className="tw-rounded-r0 tw-overflow-hidden tw-border-border-secondary tw-bg-surface-primary tw-mt-s1">
        {filteredProjects.length === 0 ? (
          <NoAssignProject onClickAddProject={onToEditMode} className="tw-py-s4" />
        ) : (
          <AssignProjectList projects={filteredProjects} onClickRow={onClickRow} />
        )}
      </div>
    </div>
  )
}
